// ===== Production Configuration =====

export const CONFIG = {
  // WebRTC Configuration
  WEBRTC: {
    ICE_SERVERS: [
      { urls: 'stun:stun.l.google.com:19302' },
      { urls: 'stun:stun1.l.google.com:19302' },
      { urls: 'stun:stun2.l.google.com:19302' },
      { urls: 'stun:stun.services.mozilla.com' },
      { urls: 'stun:stun.ekiga.net' }
    ],
    ICE_CANDIDATE_POOL_SIZE: 10,
    ICE_TRANSPORT_POLICY: 'all',
    BUNDLE_POLICY: 'max-bundle',
    RTCP_MUX_POLICY: 'require',
    VIDEO_CONSTRAINTS: {
      width: { min: 320, ideal: 640, max: 1280 },
      height: { min: 240, ideal: 480, max: 720 },
      frameRate: { ideal: 30, max: 30 },
      facingMode: 'user'
    },
    AUDIO_CONSTRAINTS: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      sampleRate: { ideal: 44100 }
    }
  },

  // Socket Configuration
  SOCKET: {
    TIMEOUT: 20000,
    RECONNECTION_ATTEMPTS: 5,
    RECONNECTION_DELAY: 1000,
    RECONNECTION_DELAY_MAX: 5000,
    TRANSPORTS: ['polling', 'websocket']
  },

  // Call Configuration
  CALL: {
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
    ICE_CONNECTION_TIMEOUT: 30000,
    CONNECTION_CHECK_INTERVAL: 5000
  },

  // Message Configuration
  MESSAGE: {
    MAX_LENGTH: 1000,
    BATCH_SIZE: 50,
    HISTORY_LIMIT: 100,
    RETRY_ATTEMPTS: 3
  },

  // UI Configuration
  UI: {
    NOTIFICATION_DURATION: 5000,
    MAX_NOTIFICATIONS: 5,
    MAX_CALL_HISTORY: 50,
    LOADING_TIMEOUT: 10000,
    EMOJI_PICKER_EMOJIS: [
      '😀', '😂', '😍', '😢', '😮', '😡', 
      '👍', '👏', '❤️', '🙏', '✨', '🎉', 
      '💯', '🔥', '👌', '💪'
    ]
  },

  // Security Configuration
  SECURITY: {
    MAX_MESSAGE_RATE: 10, // messages per minute
    SANITIZE_HTML: true,
    VALIDATE_URLS: true,
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'audio/wav', 'audio/webm', 'audio/mp3', 'audio/ogg'],
    ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"]
  },

  // Performance Configuration
  PERFORMANCE: {
    ENABLE_MONITORING: process.env.NODE_ENV === 'production',
    DEBOUNCE_DELAY: 300,
    THROTTLE_DELAY: 1000,
    LAZY_LOAD_THRESHOLD: 20
  }
};

// Environment-specific overrides
if (process.env.NODE_ENV === 'development') {
  CONFIG.WEBRTC.ICE_SERVERS.push({
    urls: 'turn:localhost:3478',
    username: 'test',
    credential: 'test'
  });
  
  CONFIG.SOCKET.TIMEOUT = 10000;
  CONFIG.UI.NOTIFICATION_DURATION = 3000;
}

if (process.env.NODE_ENV === 'production') {
  // Add production TURN servers
  CONFIG.WEBRTC.ICE_SERVERS.push({
    urls: process.env.REACT_APP_TURN_SERVER,
    username: process.env.REACT_APP_TURN_USERNAME,
    credential: process.env.REACT_APP_TURN_CREDENTIAL
  });
}

export default CONFIG;
